import Card from '../../components/ui/Card'
import { formatCurrency } from '../../lib/format'

function MonthlyBreakdown({ transactions }) {
  // Group by month
  const byMonth = transactions.reduce((acc, t) => {
    const date = new Date(t.date)
    const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`

    if (!acc[monthKey]) {
      acc[monthKey] = { revenue: 0, expenses: 0 }
    }

    if (t.type === 'revenue') {
      acc[monthKey].revenue += parseFloat(t.amount)
    } else {
      acc[monthKey].expenses += parseFloat(t.amount)
    }

    return acc
  }, {})

  const months = Object.entries(byMonth)
    .map(([month, data]) => ({
      month,
      label: new Date(month + '-01').toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
      }),
      ...data,
      profit: data.revenue - data.expenses,
    }))
    .sort((a, b) => b.month.localeCompare(a.month))
    .slice(0, 12) // Last 12 months

  return (
    <Card>
      <h3 className="card-title mb-4">Monthly Breakdown</h3>

      {months.length === 0 ? (
        <p className="text-muted">No data to display</p>
      ) : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Month</th>
                <th style={{ textAlign: 'right' }}>Revenue</th>
                <th style={{ textAlign: 'right' }}>Expenses</th>
                <th style={{ textAlign: 'right' }}>Profit</th>
              </tr>
            </thead>
            <tbody>
              {months.map(month => (
                <tr key={month.month}>
                  <td>{month.label}</td>
                  <td style={{ textAlign: 'right' }}>
                    <span className="amount positive">
                      {formatCurrency(month.revenue)}
                    </span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <span className="amount negative">
                      {formatCurrency(month.expenses)}
                    </span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <span className={`amount ${month.profit >= 0 ? 'positive' : 'negative'}`}>
                      {formatCurrency(month.profit)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  )
}

export default MonthlyBreakdown
